import { Injectable } from '@angular/core';
import { Observable, of, from, fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
@Injectable()
export class RedirectService {
    constructor() {}

    post(obj, url, contentType){
        var mapForm = document.createElement("form");
        mapForm.target = "_self";
        mapForm.method = "POST";
        mapForm.action = url;
        mapForm.contentType = contentType;
        if (typeof(obj) === 'object') {
            Object.keys(obj).forEach(function(param) {
                var mapInput = document.createElement("input");
                mapInput.type = "hidden";
                mapInput.name = param;
                mapInput.setAttribute("value", obj[param]);
                mapForm.appendChild(mapInput);
            });
        }else if (typeof(obj) === 'string') {
            var mapInput = document.createElement("input");
            mapInput.type = "hidden";
            mapInput.name = "cxml-urlencoded";
            mapInput.setAttribute("value", obj);
            mapForm.appendChild(mapInput);
        }

        document.body.appendChild(mapForm);
        mapForm.submit();
    }
}
